/**
 * amber is written in lower case as a brand name, wherever the copy comes from (API
 * tags such as "Amber Exclusive", shared translations). "Amber Plus" is the exception:
 * the product's name is kept as written.
 */
const brandCase = (text: string) =>
  text.replace(/\bAmber Plus\b/gi, "Amber Plus").replace(/\bAmber\b(?! Plus)/g, "amber");

export default brandCase;
